
























































import {
  defineComponent, useContext,
} from '@nuxtjs/composition-api';
import PictureItem from "~/components/Palmers/BaseComponents/Picture/PictureItem.vue";

export default defineComponent({
  name: 'SideImageBannerNew',
  components: {
    PictureItem
  },
  props: {
    image: {
      type: String,
      require: true
    },
    imagePosition: {
      type: String,
      require: true,
      default: () => {
        return 'left'
      }
    },
    imageType: {
      type: String,
      require: true
    },
    actions:{
      type: Boolean,
      default: false,
    },
    buttons: {
      type: Object,
      require: true
    },
    content: {
      type: Object,
      require: true
    },
    imageAlt: {
      type: String,
      require: true
    },
    imageMaxWidth: {
      type: String,
      require: true,
      default: () => {
        return '100%'
      }
    },
    source: {
      type: String,
      default() {
        return 'default'
      }
    },
    position: {
      type: Object,
      default() {
        return {
          text: 'left',
          content: 'bottom-right'
        }
      }
    }
  },
  setup() {
    const {$vsf, $config} = useContext();

    return {
      magentoBaseUrl: $vsf.$magento.config.magentoBaseUrl,
      magentoMediaUrl: $config.magentoMediaUrl
    }
  },
  methods: {
    getSource() {
      if (this.source === 'default') {
        return this.magentoBaseUrl;
      } else {
        return this.magentoMediaUrl;
      }
    }
  }
});
